import {Divider, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const Cinco = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}><b>Key Success Factors</b></Paragraph>
        <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh'}}>Product&apos;s features, quality and ease of use</Paragraph>
        <Text className='BaseText2'>The iMoAge device is characterized because it can be used without any trouble, as well as, the results are easy to understand. Also it works for everyone no matter their physical status, socioeconomic status or age.</Text>
        <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh'}}>Access to distribution channels</Paragraph>
        <Text className='BaseText2'>Companies can sell the kit in drugstores, supermarkets and online. Also it is possible to sell it in hospitals and for research.</Text>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}><b>Industry Trends</b></Paragraph>
        <Text className='BaseText2'>The industry rivalry within the market that iMoAge aims to enter - the point-of-care rapid diagnostic test industry in Mexico for the detection of inflammaging - is relatively small. However there are <b>several business trends that can affect the growth and attractiveness of the lateral flow assay market of iMoAge.</b> Some of them are shown in the next image:</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '70%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-21.png'/>
          <p><b>Fig. 4.</b> Industry trends that can affect or favour iMoAge. On the left side, some trends in the health sector that affect iMoAge are shown, while on the right side the threats that can be had are represented. [1]</p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Cinco;
